import React, { useState, useEffect } from "react";
import HeaderReport from "../../../../components/header/report";
import { Plus } from "lucide-react";
import {
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	Paper,
	TableContainer,
	CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CustomPagination from "../../../../components/paginate";
import FilterRegister from "../../../../components/filter/register-basic";
import ModalMain from "../../../../components/modal";
import ModalRegisterGroup from "../modal-register-group";
import ModalSelectProductsItem from "../modal-select-item";
import ModalBindProducts from "../modal-bind-products";
import MessageDialog from "../../../../components/ui/dialog/MessageDialog";
import reqComplementos from "../../../../services/reqMultiTenant/reqComplementos";
import { toast, ToastContainer } from "react-toastify";
import HeaderListFilter from "../../../../components/header/report-filter";
import Notification from "../../../../components/toast";
import LoadingFull from "../../../../components/loading/loading-full";
import LinkIcon from "@mui/icons-material/Link";
import { Trash2 } from "lucide-react";
import functions from "../../../../util/functions";

const MainRegisterComplements = () => {
	// VARIÁVEIS DE ESTADO - DADOS API
	const [grupos, setGrupos] = useState([]);
	const [filteredGrupos, setFilteredGrupos] = useState([]);
	const [itens, setItens] = useState([]);

	// Estados de Loading
	const [isLoadingGrupos, setIsLoadingGrupos] = useState(false);
	const [isLoadingItens, setIsLoadingItens] = useState(false);
	const [errorItens, setErrorItens] = useState(false);
	const [isTogglingActive, setIsTogglingActive] = useState(false);
	const [itemToDelete, setItemToDelete] = useState(null);

	// Estados de Controle de Interface (Modal, Seleção e Paginação)
	const [grupoSelecionado, setGrupoSelecionado] = useState(null);

	// Novo Modal de Grupo
	const [isModalGroupOpen, setIsModalGroupOpen] = useState(false);
	const [idGrupoToEdit, setIdGrupoToEdit] = useState(null);

	// Novo Modal de Seleção de Itens (Substitui o RegisterItem antigo)
	const [isModalItemOpen, setIsModalItemOpen] = useState(false);

	// Novo Modal de Vínculo de Produtos
	const [isModalBindOpen, setIsModalBindOpen] = useState(false);
	const [idGrupoToBind, setIdGrupoToBind] = useState(null);
	const [descGrupoToBind, setDescGrupoToBind] = useState("");

	// Filtro Ativo UI
	const [filterData, setFilterData] = useState({
		param: { value: "descricao", label: "Descrição do Grupo" },
		paramValue: "",
		active: true,
	});
	const [filterListData, setFilterListData] = useState({});

	// Paginação
	const [page, setPage] = useState(1);
	const itemsPerPage = 15;

	// Efeitos - Fetch Inicial
	useEffect(() => {
		// Apenas inicializa o texto do filtro no cabeçalho.
		// A busca ("Listar") agora é obrigatoriamente manual pelo usuário.
		setFilterListData({
			param: { label: "Parâmetro", value: "Descrição do Grupo" },
			active: { label: "Ativo", value: "SIM" },
		});
	}, []);

	useEffect(() => {
		if (grupoSelecionado?.id_complementos_grupo) {
			fetchItens(grupoSelecionado.id_complementos_grupo);
		} else {
			setItens([]);
			setErrorItens(false);
		}
	}, [grupoSelecionado]);

	const fetchGrupos = async (rawData = null) => {
		setIsLoadingGrupos(true);
		try {
			const paramValue = rawData?.paramValue ?? filterData.paramValue;
			const active = rawData?.active ?? filterData.active;
			const paramName = rawData?.param?.value ?? filterData.param.value;

			const response = await reqComplementos.listarGrupos(paramName, paramValue, active);

			let fetchedResult = response?.data || [];

			setGrupos(fetchedResult);
			setFilteredGrupos(fetchedResult);
			setGrupoSelecionado(null); // Reseta a tabela detalhe
			setItens([]);
			setPage(1);

			// Se a chamada inicial veio limpa, simulamos um state no Header
			if (!rawData && Object.keys(filterListData).length === 0) {
				setFilterListData({
					param: { label: "Parâmetro", value: "Descrição do Grupo" },
					active: { label: "Ativo", value: "SIM" },
				});
			}
		} catch (error) {
			console.error("Erro ao listar grupos de complementos:", error);
			toast.error("Houve um erro ao buscar os grupos de complementos.");
		} finally {
			setIsLoadingGrupos(false);
		}
	};

	const callBackSubmitModalFilter = async (filteredObject, data) => {
		await fetchGrupos(data);

		// Atualiza o formato cru pro Form de Pesquisa e o formatado para o Header
		setFilterData(data);
		setFilterListData(filteredObject);

		// Fechar via Event Listener (ModalMain)
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};

	const fetchItens = async (id_grupo) => {
		setIsLoadingItens(true);
		setErrorItens(false);
		try {
			const response = await reqComplementos.listarItensGrupos(id_grupo);
			setItens(response?.data || []);
		} catch (error) {
			console.error("Erro ao listar itens do grupo:", error);
			toast.error("Houve um erro ao buscar os itens do grupo.");
			setErrorItens(true);
			setItens([]);
		} finally {
			setIsLoadingItens(false);
		}
	};

	const handleUpdateItemInline = async (item, field, value) => {
		let parsedValue = value;

		if (field === "valor_item") {
			parsedValue = functions.parseNumber(functions.removePoint(value));
		} else if (field === "qtde") {
			parsedValue = functions.parseNumber(functions.removePoint(value));
		} else if (field === "ordem") {
			parsedValue = parseInt(functions.formatInteger(value)) || 0;
		}

		// Evita requisição se o valor for idêntico
		if (item[field] == parsedValue) return;

		// Atualiza localmente para resposta rápida
		const updatedItem = { ...item, [field]: parsedValue };
		setItens((prev) => prev.map((i) => (i.id_complementos_item === item.id_complementos_item ? updatedItem : i)));

		try {
			const payload = {
				id_complementos_item: item.id_complementos_item,
				id_produto: item.id_produto,
				id_complementos_grupo: item.id_complementos_grupo,
				nome: updatedItem.nome,
				descricao: updatedItem.descricao,
				qtde: Number(updatedItem.qtde) || 0,
				valor_item: Number(updatedItem.valor_item) || 0,
				ordem: Number(updatedItem.ordem) || 0,
				ativo: item.ativo,
			};

			await reqComplementos.inserirItens([payload]);
			Notification.showToast({ message: "Salvo automaticamente!", type: "success" });
		} catch (error) {
			const errorMsg = error.response?.data?.message || error.message || "Erro desconhecido";
			Notification.showToast({ message: "Falha ao salvar: " + errorMsg, type: "error" });
			// Reverte o valor em caso de falha
			setItens((prev) => prev.map((i) => (i.id_complementos_item === item.id_complementos_item ? item : i)));
		}
	};

	const handleDeleteItem = async () => {
		if (!itemToDelete) return;

		setIsTogglingActive(true);
		try {
			await reqComplementos.deletarItem(itemToDelete);
			setItens((prev) => prev.filter((i) => i.id_complementos_item !== itemToDelete));
			Notification.showToast({ message: "Item removido com sucesso!", type: "success" });
		} catch (error) {
			const errorMsg = error.response?.data?.message || error.message || "Erro desconhecido";
			Notification.showToast({ message: "Falha ao remover: " + errorMsg, type: "error" });
		} finally {
			setIsTogglingActive(false);
			setItemToDelete(null);
		}
	};

	const handleGridKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			const currentTd = e.target.closest("td");
			const nextTd = currentTd?.nextElementSibling;
			const nextInput = nextTd?.querySelector("input");
			if (nextInput) {
				nextInput.focus();
				nextInput.select();
			} else {
				const currentTr = e.target.closest("tr");
				const nextTr = currentTr?.nextElementSibling;
				const firstInputNextRow = nextTr?.querySelector("input");
				if (firstInputNextRow) {
					firstInputNextRow.focus();
					firstInputNextRow.select();
				} else {
					e.target.blur();
				}
			}
		} else if (e.key === "ArrowDown") {
			e.preventDefault();
			const currentTr = e.target.closest("tr");
			const currentTd = e.target.closest("td");
			const cellIndex = Array.from(currentTr.children).indexOf(currentTd);
			const nextTr = currentTr.nextElementSibling;
			if (nextTr) {
				const nextInput = nextTr.children[cellIndex]?.querySelector("input");
				if (nextInput) {
					nextInput.focus();
					nextInput.select();
				}
			}
		} else if (e.key === "ArrowUp") {
			e.preventDefault();
			const currentTr = e.target.closest("tr");
			const currentTd = e.target.closest("td");
			const cellIndex = Array.from(currentTr.children).indexOf(currentTd);
			const prevTr = currentTr.previousElementSibling;
			if (prevTr) {
				const prevInput = prevTr.children[cellIndex]?.querySelector("input");
				if (prevInput) {
					prevInput.focus();
					prevInput.select();
				}
			}
		}
	};

	const validarQtde3Casas = (valor) => {
		if (!valor) return "";
		let v = valor.toString().replace(/\./g, ",");
		v = v.replace(/[^\d,]/g, "");

		const partes = v.split(",");
		if (partes.length > 2) {
			v = partes[0] + "," + partes.slice(1).join("").replace(/,/g, "");
		}

		const novasPartes = v.split(",");
		if (novasPartes.length === 2) {
			v = novasPartes[0] + "," + novasPartes[1].substring(0, 3);
		}

		return v;
	};

	// Funções de Modal e UI
	const handleOpenModalFilter = () => {
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};

	const handleOpenModalGroup = (id = null) => {
		setIdGrupoToEdit(id);
		setIsModalGroupOpen(true);
	};
	const handleCloseModalGroup = () => {
		setIsModalGroupOpen(false);
		setIdGrupoToEdit(null);
	};

	const handleOpenModalItem = () => {
		setIsModalItemOpen(true);
	};
	const handleCloseModalItem = () => {
		setIsModalItemOpen(false);
	};

	const handleOpenModalBind = (id, desc) => {
		setIdGrupoToBind(id);
		setDescGrupoToBind(desc);
		setIsModalBindOpen(true);
	};
	const handleCloseModalBind = () => {
		setIsModalBindOpen(false);
		setIdGrupoToBind(null);
		setDescGrupoToBind("");
	};

	const options = {
		identFilter: "filterComplementsGroup",
		title: "Cadastro de Complementos",
		subTitle: "Gerenciamento de Grupos e Itens",
		parametersFilter: [
			{ id: 1, label: "Descrição do Grupo", value: "descricao" },
			{ id: 2, label: "Observação", value: "obs" },
		],
	};

	return (
		<>
			{isTogglingActive && <LoadingFull mensagem="Alterando status do item..." />}
			<ToastContainer />
			<div className="container-register pb-20">
				<header className="mt-page mb-6">
					<div className="grid grid-cols-2">
						<div className="col-span-1">
							<HeaderReport title={options.title} subTitle={options.subTitle} />
						</div>
						<div className="col-span-1 flex justify-end">
							<HeaderListFilter filterData={filterListData} />
						</div>
					</div>

					<ModalMain ident={options.identFilter}>
						<FilterRegister
							options={options}
							handleSubmitModalFilter={callBackSubmitModalFilter}
							reloadFilter={filterData}
						/>
					</ModalMain>

					<MessageDialog
						open={itemToDelete !== null}
						title="Remover Item"
						description="Deseja realmente remover este item do grupo? Essa ação não poderá ser desfeita."
						variant="warning"
						buttons="confirmCancel"
						onConfirm={handleDeleteItem}
						onCancel={() => setItemToDelete(null)}
						autoFocus="cancel"
					/>

					<ModalRegisterGroup
						isOpen={isModalGroupOpen}
						handleClose={handleCloseModalGroup}
						idGrupoToEdit={idGrupoToEdit}
						gruposMock={grupos}
						setGruposMock={setGrupos}
						setFilteredGrupos={setFilteredGrupos}
						grupoSelecionado={grupoSelecionado}
						setGrupoSelecionado={setGrupoSelecionado}
						fetchGrupos={fetchGrupos}
					/>
					<ModalSelectProductsItem
						isOpen={isModalItemOpen}
						handleClose={handleCloseModalItem}
						grupoSelecionado={grupoSelecionado}
						fetchItens={() => grupoSelecionado && fetchItens(grupoSelecionado.id_complementos_grupo)}
					/>
					<ModalBindProducts
						isOpen={isModalBindOpen}
						handleClose={handleCloseModalBind}
						idGrupoSelecionado={idGrupoToBind}
						grupoDescricao={descGrupoToBind}
					/>
					<div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-4">
						<button
							className="min-w-40 btn btn-sm btn-success w-15 flex items-center justify-center gap-1"
							onClick={() => handleOpenModalGroup()}
						>
							Cadastrar grupo
						</button>
						<div className="flex gap-2 flex-wrap">
							<button className="min-w-40 btn btn-sm btn-primary w-25" onClick={handleOpenModalFilter}>
								Listar
							</button>
						</div>
					</div>
				</header>

				<main className="grid grid-cols-1 gap-8">
					{/* SEÇÃO MESTRE - Grupos de Complementos */}
					<section>
						<div className="mb-2 flex justify-between items-end">
							<h3 className="font-bold text-gray-700 m-0 text-lg">Complementos Grupo</h3>
							<span className="text-xs text-gray-500 font-medium hidden sm:block">
								Selecione um grupo para ver seus itens 👇
							</span>
						</div>

						<TableContainer component={Paper}>
							<Table size="small">
								<TableHead className="color-table">
									<TableRow>
										<TableCell align="left">
											<span className="text-color-table">Descrição</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Observação</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Qtde</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Ordem</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Ativo</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Obrigatório</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table" title="Substitui Preço Base">
												Subitem
											</span>
										</TableCell>
										<TableCell align="center">
											<span className="text-color-table">Ações</span>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{isLoadingGrupos ? (
										<TableRow>
											<TableCell colSpan={6} align="center" className="py-8">
												<CircularProgress size={24} />
											</TableCell>
										</TableRow>
									) : filteredGrupos.length === 0 ? (
										<TableRow>
											<TableCell colSpan={6} align="center" className="py-8 text-gray-500">
												Nenhum grupo de complemento encontrado.
											</TableCell>
										</TableRow>
									) : (
										filteredGrupos
											.slice((page - 1) * itemsPerPage, page * itemsPerPage)
											.map((g) => (
												<TableRow
													key={g.id_complementos_grupo}
													onClick={() => setGrupoSelecionado(g)}
													selected={
														grupoSelecionado?.id_complementos_grupo ===
														g.id_complementos_grupo
													}
													sx={
														grupoSelecionado?.id_complementos_grupo ===
														g.id_complementos_grupo
															? {
																	backgroundColor:
																		"rgba(25, 118, 210, 0.12) !important",
																	"& > td": { fontWeight: "bold" },
																	borderLeft: "4px solid #1976d2",
																}
															: {}
													}
													className="zebra-row cursor-pointer transition-colors"
													hover
												>
													<TableCell align="left">{g.descricao}</TableCell>
													<TableCell align="center">{g.obs}</TableCell>
													<TableCell align="center">{g.qtde_max_escolha}</TableCell>
													<TableCell align="center">{g.ordem}</TableCell>
													<TableCell align="center">{g.ativo ? "Sim" : "Não"}</TableCell>
													<TableCell align="center">
														{g.obrigatorio ? "Sim" : "Não"}
													</TableCell>
													<TableCell align="center">
														{g.subitem ? (
															<div
																className="badge_status bg_red"
																title="Este grupo altera o preço base do produto"
															>
																Sim
															</div>
														) : null}
													</TableCell>
													<TableCell align="center">
														<div className="flex justify-center gap-2">
															<button
																className="btn btn-sm btn-outline-info p-1"
																title="Vincular Produtos"
																onClick={(e) => {
																	e.stopPropagation();
																	setGrupoSelecionado(g);
																	handleOpenModalBind(
																		g.id_complementos_grupo,
																		g.descricao,
																	);
																}}
															>
																<LinkIcon fontSize="small" />
															</button>
															<button
																className="btn btn-sm btn-outline-primary p-1"
																title="Editar Grupo"
																onClick={(e) => {
																	e.stopPropagation();
																	setGrupoSelecionado(g);
																	handleOpenModalGroup(g.id_complementos_grupo);
																}}
															>
																<EditIcon fontSize="small" />
															</button>
														</div>
													</TableCell>
												</TableRow>
											))
									)}
								</TableBody>
							</Table>

							{/* Paginação */}
							{filteredGrupos.length > 0 && !isLoadingGrupos && (
								<CustomPagination
									count={Math.ceil(filteredGrupos.length / itemsPerPage)}
									page={page}
									onChangePage={(event, newPage) => {
										setPage(newPage);
									}}
									totalRecord={filteredGrupos.length}
									totalPage={Math.ceil(filteredGrupos.length / itemsPerPage)}
								/>
							)}
						</TableContainer>
					</section>

					{/* SEÇÃO DETALHE - Itens do Grupo Selecionado */}
					{grupoSelecionado && (
						<section className="mt-4 transform transition-all duration-300">
							<div className="mb-2 flex justify-between items-end flex-wrap gap-4">
								<h3 className="font-bold text-gray-700 m-0 text-lg flex items-center gap-2">
									Complementos Itens
									<span className="text-blue-600 bg-blue-100 px-2 py-0.5 rounded-md text-sm hidden sm:block">
										Grupo: {grupoSelecionado.descricao}
									</span>
								</h3>
								<button
									className="btn btn-sm btn-primary flex items-center gap-1"
									onClick={handleOpenModalItem}
								>
									<Plus size={16} /> Adicionar Itens
								</button>
							</div>

							<TableContainer component={Paper}>
								<Table size="small">
									<TableHead className="color-table">
										<TableRow>
											<TableCell align="left">
												<span className="text-color-table">Nome do Item</span>
											</TableCell>
											<TableCell align="left">
												<span className="text-color-table">Descrição</span>
											</TableCell>
											<TableCell align="center">
												<span className="text-color-table">Retirar qtde. do estoque</span>
											</TableCell>
											<TableCell align="right">
												<span className="text-color-table">Valor (R$)</span>
											</TableCell>
											<TableCell align="center">
												<span className="text-color-table">Ordem</span>
											</TableCell>
											<TableCell align="center">
												<span className="text-color-table">
													Ativo &nbsp;&nbsp; / &nbsp;&nbsp; Ações
												</span>
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{isLoadingItens ? (
											<TableRow>
												<TableCell colSpan={6} align="center" className="py-8">
													<CircularProgress size={24} />
												</TableCell>
											</TableRow>
										) : errorItens ? (
											<TableRow>
												<TableCell
													colSpan={6}
													align="center"
													className="py-8 text-red-500 font-medium"
												>
													Erro de conexão ao buscar os itens deste grupo.
												</TableCell>
											</TableRow>
										) : itens.length === 0 ? (
											<TableRow>
												<TableCell colSpan={6} align="center" className="py-8 text-gray-500">
													Nenhum item cadastrado para este grupo.
												</TableCell>
											</TableRow>
										) : (
											itens.map((item) => (
												<TableRow key={item.id_complementos_item} className="zebra-row" hover>
													<TableCell align="left">
														<input
															type="text"
															className="w-full bg-transparent border border-transparent hover:border-gray-300 focus:border-blue-500 rounded px-2 py-1 outline-none transition-colors"
															defaultValue={item.nome}
															onKeyDown={handleGridKeyDown}
															onBlur={(e) =>
																handleUpdateItemInline(item, "nome", e.target.value)
															}
														/>
													</TableCell>
													<TableCell align="left">
														<input
															type="text"
															className="w-full bg-transparent border border-transparent hover:border-gray-300 focus:border-blue-500 rounded px-2 py-1 outline-none transition-colors text-gray-500 italic"
															defaultValue={item.descricao || ""}
															placeholder="Opcional..."
															onKeyDown={handleGridKeyDown}
															onBlur={(e) =>
																handleUpdateItemInline(
																	item,
																	"descricao",
																	e.target.value,
																)
															}
														/>
													</TableCell>
													<TableCell align="center">
														<input
															type="text"
															className="w-24 text-center bg-transparent border border-transparent hover:border-gray-300 focus:border-blue-500 rounded px-2 py-1 outline-none transition-colors"
															defaultValue={item.qtde?.toString().replace(".", ",")}
															onKeyDown={handleGridKeyDown}
															onChange={(e) =>
																(e.target.value = validarQtde3Casas(e.target.value))
															}
															onBlur={(e) =>
																handleUpdateItemInline(item, "qtde", e.target.value)
															}
														/>
													</TableCell>
													<TableCell align="right">
														<input
															type="text"
															className="w-24 text-right bg-transparent border border-transparent hover:border-gray-300 focus:border-blue-500 rounded px-2 py-1 outline-none transition-colors"
															defaultValue={functions.formatarMoeda(
																(item.valor_item || 0).toFixed(2).replace(".", ""),
															)}
															onKeyDown={handleGridKeyDown}
															onChange={(e) =>
																(e.target.value = functions.formatarMoeda(
																	e.target.value,
																))
															}
															onBlur={(e) =>
																handleUpdateItemInline(
																	item,
																	"valor_item",
																	e.target.value,
																)
															}
														/>
													</TableCell>
													<TableCell align="center">
														<input
															type="text"
															className="w-16 text-center bg-transparent border border-transparent hover:border-gray-300 focus:border-blue-500 rounded px-2 py-1 outline-none transition-colors"
															defaultValue={item.ordem}
															onKeyDown={handleGridKeyDown}
															onChange={(e) =>
																(e.target.value = functions.formatInteger(
																	e.target.value,
																))
															}
															onBlur={(e) =>
																handleUpdateItemInline(item, "ordem", e.target.value)
															}
														/>
													</TableCell>
													<TableCell align="center">
														<div className="flex justify-center gap-6">
															<button
																className={`btn btn-sm ${item.ativo ? "btn-outline-success" : "btn-outline-danger"} p-1`}
																onClick={async () => {
																	setIsTogglingActive(true);
																	try {
																		await reqComplementos.ativarItem(
																			item.id_complementos_item,
																			!item.ativo,
																		);
																		setItens((prev) =>
																			prev.map((i) =>
																				i.id_complementos_item ===
																				item.id_complementos_item
																					? { ...i, ativo: !i.ativo }
																					: i,
																			),
																		);
																		Notification.showToast({
																			message: `Item ${!item.ativo ? "ativado" : "desativado"} com sucesso!`,
																			type: "success",
																		});
																	} catch (error) {
																		const errorMsg =
																			error.response?.data?.message ||
																			error.message ||
																			"Erro desconhecido";
																		Notification.showToast({
																			message:
																				"Falha ao alterar status: " + errorMsg,
																			type: "error",
																		});
																	} finally {
																		setIsTogglingActive(false);
																	}
																}}
																title={item.ativo ? "Desativar Item" : "Ativar Item"}
															>
																{item.ativo ? (
																	<CheckIcon fontSize="small" />
																) : (
																	<CloseIcon fontSize="small" />
																)}
															</button>
															<button
																className="btn btn-sm btn-outline-danger p-1"
																onClick={() =>
																	setItemToDelete(item.id_complementos_item)
																}
																title="Remover Item"
															>
																<Trash2 size={18} />
															</button>
														</div>
													</TableCell>
												</TableRow>
											))
										)}
									</TableBody>
								</Table>
							</TableContainer>
							<div className="mt-2.5 text-xs text-gray-500 italic flex items-center gap-1.5 justify-end">
								<span className="h-2 w-2 rounded-full bg-emerald-500 animate-pulse"></span>
								Os itens são salvos automaticamente após cada alteração.
							</div>
						</section>
					)}
				</main>
			</div>
		</>
	);
};

export default MainRegisterComplements;
